import React from 'react';

import { Box, Chip, Typography } from '@mui/material';

import { HiddenDepartureStatus, LereToursPricingSuggestion } from '../types';

function formatNumber(value: number | null): string {
  if (value == null) {
    return '—';
  }
  return value.toLocaleString();
}

function formatPercent(value: number | null): string {
  if (value == null) {
    return '—';
  }
  return `${(value * 100).toFixed(1)}%`;
}

const HIDDEN_STATUS_CONFIG: Record<HiddenDepartureStatus, { label: string; color: 'default' | 'warning' | 'error' }> = {
  not_hidden: { label: 'Not Hidden', color: 'default' },
  partially_hidden: { label: 'Partially Hidden', color: 'warning' },
  fully_hidden: { label: 'Fully Hidden', color: 'error' },
};

export default function ToursCapacitySalesFormatter({ row }: { row: LereToursPricingSuggestion }) {
  const hiddenConfig = HIDDEN_STATUS_CONFIG[row.hidden_departure_status] ?? HIDDEN_STATUS_CONFIG.not_hidden;

  return (
    <Box sx={{ alignSelf: 'flex-start', py: 1 }}>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Pax Sold / Max:
        </Typography>{' '}
        {formatNumber(row.total_pax_sold)} / {formatNumber(row.max_pax)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Hedged Pax:
        </Typography>{' '}
        {formatNumber(row.hedged_pax)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Book Rate:
        </Typography>{' '}
        {formatPercent(row.current_book_rate)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Predicted Pax:
        </Typography>{' '}
        {row.predicted_total_pax ?? '—'}
      </Typography>
      <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography component="span" fontWeight="bold" variant="body2">
          Hidden:
        </Typography>{' '}
        <Chip label={hiddenConfig.label} color={hiddenConfig.color} size="small" variant="outlined" />
      </Typography>
      {row.ddop_status && (
        <Typography variant="body2">
          <Typography component="span" fontWeight="bold" variant="body2">
            DDOP:
          </Typography>{' '}
          {row.ddop_status}
        </Typography>
      )}
    </Box>
  );
}
